import { rows, DataGrid } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import App from "../controllers/App/App";
import AppNewLogic from "../controllers/App/AppNewLogic";
import { getConfigVariable } from "../config/config";
import { hasModule } from "../utils/utils";

const AuditNotesController = (props) => {
    const { modules } = props;
    const modifiedProps = { ...props, hideNewMenu: true, hasHeroBanner: true, }
    const Controller = hasModule(modules, "new_navigation") ? AppNewLogic : App;
    return <Controller {...modifiedProps} />;
};

const queries = (args = {}) => {
    return [
        {
            resource: `nc_audit_notes`,
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear,
                importId: args.importId,
                page: parseInt(args.page, 10) || 0,
                filter: args.filter
                    ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                    : undefined,
                sort: args.sort
                    ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                    : undefined,
                pageSize: parseInt(
                    args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE"),
                ),
            },
            downloadable: true,
            xlsxTranslation: `nc_audit_notes`,
            body: `__typename, items{...nc_audit_notes}, hasMore, total, filters(projectId:$projectId, fiscalYear:$fiscalYear, importId:$importId){ prop, name, type, list, disableOperators, mandatory }`,
            isDatagridReq: true,
            forceRefresh: true,
        },
        {
            resource: "data_files_types_present",
            args: {
                projectId: args.projectId,
            },
            body: "hasSource, hasLegal",
        },
    ];
};

const auditNoteByFile = (path, navigation, exact, title, navByImportId = false) => ({
    path,
    navigation,
    component: AuditNotesController,
    exact,
    navByImportId,
    queries,
    title,
    hasSource: "query(1).hasSource",
    hasLegal: "query(1).hasLegal",
    components: [
        {
            component: DataGrid,
            modifiers: ["--root-margin-top-small", "--row-style-alternate"],
            props: {
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                id: "results",
                items: "query(0).list",
                card: rows.CellCard,
                sort: "param(sort)",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                footer: "query(0).footer",
                header: "query(0).header",
                adjustStickyTop: true,
            },
        },
    ],
});

export default auditNoteByFile;
